module.exports = __webpack_public_path__ + "assets/img/36@3x.ab35da7a.png";